export default __webpack_public_path__ + "static/color-picker-agnostic-color-do-23bf8d2df8921e2e08f9827795329e04.png";